import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
  tableType?: string;
  drawerType?: string;
} = {
  // light  realDark
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#0A7F42',
  layout: 'mix',
  contentWidth: 'Fluid',
  siderMenuType: 'sub',

  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,

  // 中储粮智慧包仓考核管理系统 智慧包仓考核系统
  title: '中储粮智慧包仓考核管理系统',
  pwa: true,
  logo: '/logo-l.png',
  iconfontUrl: '',
  token: {
    //     colorBgAppListIconHover: 'rgba(0,0,0,0.06)',
    //     colorTextAppListIconHover: 'rgba(255,255,255,0.95)',
    //     colorTextAppListIcon: 'rgba(255,255,255,0.85)',
    //     sider: {
    //       colorBgCollapsedButton: '#fff',
    //       colorTextCollapsedButtonHover: 'rgba(0,0,0,0.65)',
    //       colorTextCollapsedButton: 'rgba(0,0,0,0.45)',
    //       colorMenuBackground: 'rgba(0, 0, 0, 0.88)',
    //       colorBgMenuItemCollapsedElevated: 'rgba(0,0,0,0.85)',
    //       colorMenuItemDivider: 'rgba(255,255,255,0.15)',
    //       colorBgMenuItemHover: 'rgba(0,0,0,0.06)',
    //       colorBgMenuItemSelected: 'rgba(0,0,0,0.15)',
    //       colorTextMenuSelected: '#fff',
    //       colorTextMenuItemHover: 'rgba(255,255,255,0.75)',
    //       colorTextMenu: 'rgba(255,255,255,0.75)',
    //       colorTextMenuSecondary: 'rgba(255,255,255,0.65)',
    //       colorTextMenuTitle: 'rgba(255,255,255,0.95)',
    //       colorTextMenuActive: 'rgba(255,255,255,0.95)',
    //       colorTextSubMenuSelected: '#fff',
    //     },
    //     header: {
    //       colorBgHeader: '#387c47',
    //       colorBgRightActionsItemHover: 'rgba(0,0,0,0.06)',
    //       colorTextRightActionsItem: 'rgba(255,255,255,0.65)',
    //       colorHeaderTitle: '#fff',
    //       colorBgMenuItemHover: 'rgba(0,0,0,0.06)',
    //       colorBgMenuItemSelected: 'rgba(0,0,0,0.15)',
    //       colorTextMenuSelected: '#fff',
    //       colorTextMenu: 'rgba(255,255,255,0.75)',
    //       colorTextMenuSecondary: 'rgba(255,255,255,0.65)',
    //       colorTextMenuActive: 'rgba(255,255,255,0.95)',
    //     },
  },
  collapsed: false,
  tableType: 'center',
  drawerType: 'right',
};

export default Settings;
